import Leaflet from 'leaflet'
import { Bbox, Feature, GeomType, PreparedTile, transformGeom, View } from 'protomaps-leaflet'

const MARKER_BOUNDS_PADDING_RATIO = 0.5

export interface LocatedFeature {
  feature: Feature
  latLng: Leaflet.LatLng
}

export async function queryPointFeatures(
  view: View,
  map: Leaflet.Map,
  dataLayer: string,
  zoom: number,
  filter: (feature: Feature) => boolean
): Promise<LocatedFeature[]> {
  const bounds = map.getBounds()
  const bbox = projectBounds(map, bounds, zoom)
  const markerBbox = projectBounds(map, bounds.pad(MARKER_BOUNDS_PADDING_RATIO), zoom)

  const tiles = await view.getBbox(zoom, bbox)

  const located: LocatedFeature[] = []

  for (const tile of tiles) {
    for (const feature of tile.data.get(dataLayer) ?? []) {
      if (feature.geomType !== GeomType.Point || !filter(feature)) {
        continue
      }
      const [[point]] = transformGeom(feature.geom, tile.scale, tile.origin)
      if (!isInsideTile(point, tile) || !isInsideBbox(point, markerBbox)) {
        continue
      }
      located.push({ feature, latLng: map.unproject(Leaflet.point(point.x, point.y), zoom) })
    }
  }

  return located
}

function isInsideTile({ x, y }: { x: number; y: number }, { origin, dim }: PreparedTile): boolean {
  return x >= origin.x && x < origin.x + dim && y >= origin.y && y < origin.y + dim
}

function isInsideBbox({ x, y }: { x: number; y: number }, { minX, minY, maxX, maxY }: Bbox): boolean {
  return x >= minX && x <= maxX && y >= minY && y <= maxY
}

function projectBounds(map: Leaflet.Map, bounds: Leaflet.LatLngBounds, zoom: number): Bbox {
  const northWest = map.project(bounds.getNorthWest(), zoom)
  const southEast = map.project(bounds.getSouthEast(), zoom)
  return { minX: northWest.x, minY: northWest.y, maxX: southEast.x, maxY: southEast.y }
}
